import { render, staticRenderFns } from "./DrawerLink.vue?vue&type=template&id=5ad7dd19&scoped=true&"
import script from "./DrawerLink.vue?vue&type=script&lang=js&"
export * from "./DrawerLink.vue?vue&type=script&lang=js&"
import style0 from "./DrawerLink.vue?vue&type=style&index=0&id=5ad7dd19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7dd19",
  null
  
)

export default component.exports